import { render, staticRenderFns } from "./TerminalManagement.vue?vue&type=template&id=ef644ac0&scoped=true&"
import script from "./TerminalManagement.vue?vue&type=script&lang=js&"
export * from "./TerminalManagement.vue?vue&type=script&lang=js&"
import style0 from "./TerminalManagement.vue?vue&type=style&index=0&id=ef644ac0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef644ac0",
  null
  
)

export default component.exports